import { post } from '../../../utils/services/Request'

export const getPartDetails = (body: string) => post<any>('/parker/partDetails', body)